import { mapGetters } from 'vuex';
import _ from 'lodash';
import { planTypes } from '@/common/constants';
import softBundlePlanMixin from '@/views/config/soft-bundle/mixin/soft-bundle-plan';
import { computedPbxCallingPlans, computedPbxNonBasePlans } from '@/common/service/computers/plans/pbx';
import { PBX_REGIONS } from '../helper/constants';

// softBundle4Pbx instance
export const softBundle4Pbx = {
  cycleInstance: null,
  instance: null
};

export default {
  mixins: [softBundlePlanMixin],
  data() {
    return {
      bd_planType: planTypes.ZOOM_PHONE,
    }
  },
  computed: {
    ...mapGetters(['softBundleConfiguration', 'groupByPlanCodePlanMap']),
    soft_bundle_hiddenCycleSelection() {
      return this.softBundlePlanConfig?.hiddenCycleSelection;
    },
    soft_bundle_hiddenOtherRegion() {
      return this.softBundlePlanConfig?.hiddenOtherRegion;
    },
    soft_bundle_hiddenTypeSwitch() { // uc | mc switch
      return this.softBundlePlanConfig?.hiddenTypeSwitch;
    },
    soft_bundle_hiddenAppealByoc() {
      return this.softBundlePlanConfig?.hiddenRemove;
    },
    soft_bundle_hiddenPlanCardRemove() {
      if (this.soft_bundle_showRemoveBtn) return false;
      return this.softBundlePlanConfig?.hiddenRemove;
    },
    soft_bundle_hiddenBasePlan() {
      return this.softBundlePlanConfig?.hiddenZpBasePlan;
    },
    pbx_calling_type_show_price() {
      return this.soft_bundle_hiddenCycleSelection && this.soft_bundle_hiddenBasePlan;
    },
    soft_bundle_pbxCallingRegion() {
      const callingPlans = computedPbxCallingPlans(this.soft_bundle_currentPlanList);
      return _.get(callingPlans, '[0].region', PBX_REGIONS.US_AND_CANADA);
    },
    soft_bundle_enableBillingCycle() {
      const list = computedPbxNonBasePlans(this.soft_bundle_currentPlanList);
      return this.soft_bundle_disableBillingCycleSwitch
        ? _.get(list, [0, 'billing_cycle'], '')
        : '';
    },
  },
  methods: {
    filterRegions(regions = [], activeRegionKey) {
      if (!this.soft_bundle_hiddenOtherRegion) return regions;
      return _.filter(regions, (region) => region?.key === activeRegionKey);
    },
    setPbxCardInstance() {
      if (this.depOnBasePlanListSwitchCycle?.length) {
        softBundle4Pbx.cycleInstance = this.$refs?.pbxCardRef;
      }
    },
    getDisabledCycleTipsForSoftBundle(cycle) {
      const disabledTooltip = '';

      if (this.soft_bundle_disableBillingCycleSwitch) {
        const enableBillingCycle = this.soft_bundle_enableBillingCycle;
        if (enableBillingCycle && enableBillingCycle !== cycle) {
          return this.$t('softBundle.disableCycleTips', [enableBillingCycle]);
        }
      }

      return disabledTooltip;
    }
  },
};
